<template>
  <v-content style="font-family: Microsoft JhengHei">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8>
          <v-card class="elevation-12">
            <v-toolbar color="indigo darken-1" dark flat>
              <v-toolbar-title style="color: white">
                <!-- 1:{{formMapping.formId}}
                - 2:{{formMapping.targetId}}
                - 3:{{employer.employerId}}
                Application No：
                <span style="font-size:25px">{{formMapping.formKey}}</span>-->
                <label style="font-size: 1.5em"> 實聯制登記表 </label>
              </v-toolbar-title>

              <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text>
              <v-form ref="form" v-model="valid">
                <!-- <v-col cols="12" md="12">
                  <h2>Business Information</h2>
                </v-col>
                <v-row dense>
                  <v-col cols="12" md="12">
                    <v-text-field
                      label="Name of Business"
                      type="text"
                      counter
                      maxlength="50"
                      dense
                      class="font-weight-normal"
                      v-model="employer.businessName"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="7">
                    <v-text-field
                      label="Business Address"
                      type="text"
                      counter
                      maxlength="100"
                      dense
                      class="font-weight-normal"
                      v-model="employer.address"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5">
                    <v-select
                      :items="getLesArray('district')"
                      item-text="value"
                      item-value="value"
                      label="District"
                      dense
                      v-model="employer.district"
                      class="font-weight-normal"
                      :readonly="readOnlyFlag"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-autocomplete
                      :items="getLesArray('industry')"
                      item-text="value"
                      item-value="value"
                      label="Business Industry"
                      dense
                      v-model="employer.industry"
                      class="font-weight-normal"
                      :readonly="readOnlyFlag"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                -->

                <v-row dense>
                  <v-col cols="12" md="12">
                    <v-menu
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="employer.visitDate"
                          label="日期"
                          readonly
                          v-on="on"
                          dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="employer.visitDate"
                        locale="zh-cn"
                        no-title
                        @input="menu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employer.startDate"
                      label="進來時間"
                      value="08:30:00"
                      type="time"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="employer.endDate"
                      label="出去時間"
                      value="17:30:00"
                      type="time"
                    ></v-text-field>
                  </v-col>
                  <!--
                  <v-col cols="12" md="12">
                    <v-menu
                      ref="dialog2"
                      v-model="menuS"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="computedDateFormattedS"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker v-model="startDate2" locale="zh-cn">
                        <v-btn
                          color="blue"
                          style="color: white"
                          class="ma-2"
                          @click="$refs.dialog2.save(dates2)"
                          >確定</v-btn
                        >
                      </v-time-picker>
                    </v-menu>
                  </v-col>
-->
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="來賓姓名"
                      type="text"
                      counter
                      maxlength="32"
                      dense
                      class="font-weight-normal"
                      v-model="employer.firstName"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      cols="12"
                      md="6"
                      label="聯繫方式(例：手機、家用或公司電話…)"
                      type="tel"
                      counter
                      maxlength="20"
                      dense
                      class="font-weight-normal"
                      v-model="employer.phone"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="事由(例：組長室、第一會議室)"
                      type="text"
                      counter
                      dense
                      class="font-weight-normal"
                      v-model="employer.cause"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="備註"
                      type="text"
                      counter
                      dense
                      class="font-weight-normal"
                      v-model="employer.remarks"
                      :readonly="readOnlyFlag"
                    ></v-text-field>
                  </v-col>
                </v-row>

                1.
                為維持國內疫情之穩定控制，本局配合政府「COVID-19（武漢肺炎）」防疫新生活運動，採行實聯制措施。
                <br />2.
                依據衛生福利部疾病管制署「COVID-19(武漢肺炎)防疫新生活運動：實聯制措施指引」、和「個人資料保護法」，基於公共衛生或傳染病防治之特定目的，為防堵疫情而有必要時，得提供衛生主管機關依傳染病防治法等規定進行疫情調查及聯繫使用，蒐集必要之個人資料（含姓名、電話號碼）。
                <br />3.
                您的個人資料得依個人資料保護法規定行使相關權利，本局將依個人資料保護法就以上個人資料進行妥善保護，並於蒐集日起28日後刪除或銷毀。您同意並瞭解本局蒐集、處理或利用個人資料之目的及用途。
                <br />4.
                當事人就其個人資料得依個人資料保護法規定，向經濟部標準檢驗局行使權利，包括查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止處理或利用、請求刪除等。相關權利行使方式：本人攜帶身分證明文件至本局秘書室（第三科）申辦。
                <br />5.
                當事人如無法配合本實聯制作業，將無法進入場館或參與活動。 <br />
                6. 本實聯制其他相關措施說明，請參閱http://at.cdc.tw/8QI4hA
              </v-form>
            </v-card-text>

            <ButtonFooterComponents
              :readOnlyFlag="readOnlyFlag"
              :valid="valid"
              v-on:update-item="updateButtonObject"
            ></ButtonFooterComponents>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialogNote" width="800px">
      <NoteComponents
        :noteItem="noteItem"
        v-on:childDialog="parentDialog"
      ></NoteComponents>
    </v-dialog>
    <div v-if="dialogEmployerVacancies">
      <v-dialog persistent v-model="dialogEmployerVacancies" width="800px">
        <EmployerVacanciesComponents
          :selectItem="targetEmployerVacancies"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateVacancies"
          v-on:remove-item="removeVacancies"
        ></EmployerVacanciesComponents>
      </v-dialog>
    </div>
    <div v-if="dialogEmployerTerminated">
      <v-dialog persistent v-model="dialogEmployerTerminated" width="800px">
        <EmployerTerminatedComponents
          :selectItem="targetEmployerTerminated"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateTerminated"
          v-on:remove-item="removeTerminated"
        ></EmployerTerminatedComponents>
      </v-dialog>
    </div>
    <div v-if="dialogContinue">
      <v-dialog persistent v-model="dialogContinue" width="600px">
        <ContinueKeyComponents
          :selectItem="continueKey"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateContinueKey"
        ></ContinueKeyComponents>
      </v-dialog>
    </div>
    <div v-if="dialogEntrance">
      <v-dialog persistent v-model="dialogEntrance" width="600px">
        <ContinueKeyComponents
          :selectItem="continueKey"
          v-on:childDialog="parentDialog"
          v-on:update-item="updateContinueKey"
        ></ContinueKeyComponents>
      </v-dialog>
    </div>
  </v-content>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import swal from "sweetalert2";

import { mapGetters, mapActions } from "vuex";
import NoteComponents from "../Common/NoteComponents";
import EmployerVacanciesComponents from "../Common/EmployerVacanciesComponents";
import EmployerTerminatedComponents from "../Common/EmployerTerminatedComponents";
import ContinueKeyComponents from "../Common/ContinueKeyComponents";
import EntranceComponents from "../Common/EntranceComponents";
import ButtonFooterComponents from "../Common/ButtonFooterComponents";

import Vue from "vue";

export default {
  components: {
    NoteComponents,
    EmployerVacanciesComponents,
    EmployerTerminatedComponents,
    ContinueKeyComponents,
    ButtonFooterComponents,
  },
  computed: {
    ...mapGetters({
      idbServerUrl: ["getIdbServerUrl"],
    }),
    readOnlyFlag() {
      var vm = this;
      if (vm.formMapping.status == "S") {
        return true;
      } else return false;
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      startDate2: null,
      endDate2: null,
      dialog2: false,
      menu: false,
      menuS: false,
      menuE: false,

      valid: true,
      dialogEmployerVacancies: false,
      dialogEmployerTerminated: false,
      dialogContinue: false,
      dialogEntrance: false,
      dialogNote: false,
      continueKey: null,
      formMapping: this.getlesModel("formMapping"),
      employer: this.getlesModel("employer"),
      employerTerminatedList: [],
      employerVacanciesList: [],
      targetEmployerVacancies: this.getlesModel("employerVacancies"),
      targetEmployerTerminated: this.getlesModel("employerTerminated"),
      headers: {
        employerVacanciesHeaders: [
          { text: "Job Title", value: "jobTitle", width: 60 },
          { text: "No. of Vacancies", value: "vacanciesNumber", width: 15 },
          {
            text: "Qualifications Required",
            value: "qualifications",
            width: 20,
          },
          { text: "Location of Vacancy", value: "location", width: 15 },
          { text: "No. of Weekly Working Hours", value: "hours", width: 10 },
          { text: "Start Date", value: "startDate", width: 20 },
        ],
        employerTerminatedHeaders: [
          { text: "Name", value: "name", width: 50 },
          { text: "Job Title", value: "jobTitle", width: 50 },
          // {
          //   text: "Phone No.",
          //   value: "phone",
          //   width: 10
          // },
          // {
          //   text: "Email",
          //   value: "email",
          //   width: 10
          // },
          { text: "Date of Employment", value: "dateOfEmployment", width: 10 },
          {
            text: "Date of Termination",
            value: "dateOfTermination",
            width: 10,
          },
          { text: "Salary", value: "salary", width: 10 },
          {
            text: "Indicate how Worker's salary was fixed",
            value: "paymentMethods",
            width: 20,
          },
        ],
      },
      noteItem: {},
      notes: {
        note1: {
          title: "Current Business Status",
          contentArray: [
            "Fully Closed : Business ceased operations",
            "Temporary Closed : Business closed for six (6) months or less",
            "Partialy Closed : Only some sections/departments of the business are operating",
            "Fully Operational : All sections/departments are operating",
          ],
        },
        note2: {
          title: "Entrance",
          contentArray: [
            "New Application : create a new application and get a new Application No.",
            "Resume : Use Application No. to fill in the form",
          ],
        },
      },
      inputRules: {
        numberRule: (val) => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }

          var r = /^\+?[1-9][0-9]*$/;
          if (!r.test(val) || val < 0) {
            return "Please enter Positive Integer";
          }

          // if (val < 0) {
          //   return "Please enter a positive number";
          // }
          return true;
        },
        emailRule: (val) => {
          if (!this.isNotBlankUtil(val)) {
            return true;
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(val) || "Invalid e-mail.";
        },
      },
    };
  },
  // watch: {
  //   isAppIdle: "autoSaveObject",
  // },
  methods: {
    ...mapActions(["updateAutoSaveStatus"]),
    parentDialog() {
      var vm = this;
      vm.dialogEmployerVacancies = false;
      vm.dialogEmployerTerminated = false;
      vm.dialogContinue = false;
      vm.dialogNote = false;
      vm.dialogEntrance = false;

      if ("entrance" == vm.$route.params.formKey) {
        vm.dialogEntrance = !vm.dialogEntrance;
        vm.noteItem = vm.notes.note2;
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    submitObject() {
      var vm = this;

      //vm.formMapping.status = "S";
      vm.employer.status = "S";
      vm.updateApiData().then((result2) => {
        // console.log("result2 " + result2);
        if (result2 != "ERROR") vm.successSwalUtil();
      });
    },
    tempObject() {
      var vm = this;
      vm.updateApiData().then((result2) => {
        // console.log("result2 " + result2);
        if (result2 != "ERROR") vm.successSwalUtil();
      });
    },
    updateVacancies(targetItem) {
      var vm = this;
      vm.dialogEmployerVacancies = false;

      if (targetItem.vacanciesId == "init") {
        var date = new Date();
        targetItem.vacanciesId =
          "init" +
          date.getFullYear() +
          date.getMonth() +
          1 +
          date.getDate() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds();
        vm.employerVacanciesList.push(targetItem);
      } else {
        vm.employerVacanciesList.forEach(function (item, index, array) {
          if (item.vacanciesId == targetItem.vacanciesId) {
            vm.employerVacanciesList.splice(index, 1, targetItem);
          }
        });
      }
    },
    removeVacancies(targetItem) {
      var vm = this;
      vm.dialogEmployerVacancies = false;
      vm.employerVacanciesList.forEach(function (item, index, array) {
        if (item.vacanciesId == targetItem.vacanciesId) {
          vm.employerVacanciesList.splice(index, 1);
        }
      });
    },
    updateTerminated(targetItem) {
      var vm = this;
      vm.dialogEmployerTerminated = false;

      if (targetItem.terminatedId == "init") {
        var date = new Date();
        targetItem.terminatedId =
          "init" +
          date.getFullYear() +
          date.getMonth() +
          1 +
          date.getDate() +
          date.getHours() +
          date.getMinutes() +
          date.getSeconds();
        vm.employerTerminatedList.push(targetItem);
      } else {
        vm.employerTerminatedList.forEach(function (item, index, array) {
          if (item.terminatedId == targetItem.terminatedId) {
            vm.employerTerminatedList.splice(index, 1, targetItem);
          }
        });
      }
    },
    removeTerminated(targetItem) {
      var vm = this;
      vm.dialogEmployerTerminated = false;
      vm.employerTerminatedList.forEach(function (item, index, array) {
        if (item.terminatedId == targetItem.terminatedId) {
          vm.employerTerminatedList.splice(index, 1);
        }
      });
    },
    updateContinueKey(value) {
      var vm = this;
      vm.$router.push({
        path: "/FormEmployer/" + value,
      });
      // vm.continueObject(value);
      // console.log("updateContinueKey value " + value);
    },
    updateEntrance(value) {
      var vm = this;
      if (value == "init") {
        vm.$router.push({
          path: "/FormEmployer/init",
        });
      } else if (value == "continue") {
        vm.dialogContinue = !vm.dialogContinue;
      }
      this.dialogEntrance = false;
    },
    // autoSaveObject() {
    //   var vm = this;
    //   // console.log(" vm.formMapping " + vm.formMapping.formId);

    //   if (
    //     vm.formMapping.formId == null ||
    //     vm.formMapping.status == "S" ||
    //     !vm.valid ||
    //     vm.dialogEmployerVacancies ||
    //     vm.dialogEmployerTerminated ||
    //     vm.dialogContinue ||
    //     vm.dialogEntrance ||
    //     vm.dialogNote
    //   ) {
    //     return;
    //   }
    //   if (this.isAppIdle) {
    //     vm.updateApiData();
    //   } else {
    //     // vm.updateAutoSaveStatus("N");
    //   }
    // },
    updateApiData() {
      var vm = this;
      delete vm.employer.employerTerminatedSet;
      delete vm.employer.employerVacanciesSet;
      var visitDateValue = vm.employer.visitDate;
      var phoneValue = vm.employer.phone;
      var flag = true;
      if (visitDateValue == null) {
        flag = false;

        swal("請輸入日期");
      }

      if (phoneValue == null) {
        flag = false;

        swal("請輸入聯絡方式");
      }
      vm.employer.startDate = vm.employer.startDate.substr("0", "5");
      vm.employer.endDate = vm.employer.endDate.substr("0", "5");

      var data = {
        employerBean: {
          employer: vm.employer,
        },
      };
      if (flag) {
        var foo = vm.axios
          .post(vm.idbServerUrl + "les/form/lesFormAdd", data, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then(function (response) {
            vm.$router.push({
              path: "/employerDisplay/" + phoneValue + "/" + visitDateValue,
            });
          })
          .catch(function (error) {
            vm.handErrorUtil(error);
            //   vm.formMapping.status = "T";
            vm.employer.status = "T";
            console.log("!!!! " + error);
            return "ERROR";
          });
        return foo;
      } else {
        vm.newObject();
      }
    },
    newObject() {
      var vm = this;
      vm.employer.employerId = "init";

      var data = "FORM_EMPLOYER";
      vm.axios
        .post(vm.idbServerUrl + "les/form/lesForm", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          vm.formMapping = response.data;
        })
        .catch(function (error) {
          vm.handErrorUtil(error);
          console.log("!!!! " + error);
        });
    },
    continueObject(value) {
      var vm = this;

      vm.axios
        .get(vm.idbServerUrl + "les/form/lesForm/" + value, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          console.log("response " + JSON.stringify(response.data));
          if (response.data.formMapping == null) {
            vm.NotFindApplicationUtil(value);

            return;
          }
          vm.formMapping = response.data.formMapping;
          vm.employer = response.data.employerBean.employer;
          vm.employerTerminatedList =
            response.data.employerBean.employerTerminatedList;
          vm.employerVacanciesList =
            response.data.employerBean.employerVacanciesList;
          vm.employerTerminatedList.forEach((result) => {
            result.dateOfEmployment = vm.convertDBDateToString(
              result.dateOfEmployment
            );
            result.dateOfTermination = vm.convertDBDateToString(
              result.dateOfTermination
            );
          });
          vm.employerVacanciesList.forEach((result) => {
            result.startDate = vm.convertDBDateToString(result.startDate);
          });
          // console.log("SUCCESS!!!!!!! ");
        })
        .catch(function (error) {
          vm.handErrorUtil(error);
        });
    },
    updateButtonObject(type) {
      let vm = this;
      console.log("type " + type);
      if ("Entrance" == type) {
        vm.updateContinueKey("entrance");
      } else if ("Resume" == type) {
        vm.dialogContinue = !vm.dialogContinue;
      } else if ("Submit" == type) {
        vm.submitObject();
      } else if ("Temp" == type) {
        vm.tempObject();
      }
    },
  },
  mounted() {
    let vm = this;
    if ("init" == vm.$route.params.formKey) {
      vm.newObject();
    } else if ("entrance" == vm.$route.params.formKey) {
      vm.dialogEntrance = !vm.dialogEntrance;
      vm.noteItem = vm.notes.note2;
    } else {
      vm.continueObject(vm.$route.params.formKey);
    }
    // this.employerVacanciesList.push({
    //   hours: 12,
    //   jobTitle: "Accountants",
    //   location: "Caye Caulker Village",
    //   qualifications: "Bachelor's Degree",
    //   startDate: "2020-03-05",
    //   vacanciesId: "1223477",
    //   vacanciesNumber: 3
    // });
    // this.employerTerminatedList.push({
    //   dateOfEmployment: "2020-03-05",
    //   dateOfTermination: "2020-03-05",
    //   email: "jugan.74111@gmail.com",
    //   jobTitle: "Administrative and executive secretaries",
    //   name: "周欣翰111",
    //   paymentMethods: "Commission",
    //   phone: "0963555802",
    //   salary: "12213"
    // });
  },
  created() {
    let vm = this;

    // console.log("!!!!!!!! " + vm.$route.params.formKey);
  },
  beforeDestroy() {},
};
</script>




